import { getPath } from '@/router/common'
const baseUrl = {
  title: '配载清单打印',
  path: 'test'
}

export default []
